<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
import Echo from "laravel-echo";

var moment = require('moment/moment.js');
var auth = require('./services/auth.js');
var postAnythingStore = require('./stores/post-anything.js');
var _ = require('underscore');

// Pusher/Echo
window.Pusher = require('pusher-js');
window.Echo = new Echo({
    broadcaster: 'pusher',
    key: PUSHER_APP_KEY,
    cluster: PUSHER_APP_CLUSTER,
    forceTLS: true
});

export default {
    created: function() {
        postAnythingStore.$app = this;
        this.$root.defaultTheme = DEFAULT_THEME;

        //activate intercom guest mode for guest routes
        if(this.$route.meta.guest === true){
            eventHub.$emit('guest-account');
        }

        var routeLanguage = this.$route.query ? this.$route.query.lang : null;
        var storedLanguage = sessionStorage.language ? sessionStorage.language : 'en';
        var language = routeLanguage ? routeLanguage : storedLanguage;

        this.$setLanguage(language);

        var self = this;

        eventHub.$on('user.login', function(profile, remember) {self.eventUserLogin(profile, remember);});
        eventHub.$on('guest-account', function() {self.activateGuestIntercom();});
        eventHub.$on('user.logout', function() {self.eventUserLogout();});
        eventHub.$on('user.refresh-profile', function() {if (auth.isAuthenticated()) {self.fetchProfile();}});
        eventHub.$on('user.profile', function(profile) {self.eventUserProfile(profile, false);});
        eventHub.$on('user.profile-updated', function(profile) {self.eventUserProfile(profile, true);});
        eventHub.$on('masquerading.started', function() {self.eventMasqueradingStarted();});
    },

    mounted: function() {
        var self = this;

        this.$nextTick(function () {
            if (auth.isAuthenticated()) {
                self.fetchProfile();
            }
        });
    },
    data: function() {
        return {
            intercomBooted: false,
            user: null,
            language: null,
            defaultTheme: 'default',
            echoBooted: false
        }
    },
    methods: {
        fetchProfile: function() {
            var promise = this.$http.get('profile').then(function(response) {
                eventHub.$emit('user.profile', response.data.data);

                var company = this.user.company;

                if (company !== null) {
                    window.ga('set', 'dimension1', company.data.name);
                } else {
                    window.ga('set', 'dimension1', 'no_company');
                }
            });

            eventHub.$emit('loader', promise);
        },
        switchLanguage: function(lang) {
            if(lang.length === 5) {
                // Correct format
                lang = lang.substring(0,2) + '_' + lang.substring(3).toUpperCase();
            }

            if (this.language === lang) {
                return;
            }

            this.$setLanguage(lang);
            moment.locale(lang);
            this.language = lang;
        },
        activateGuestIntercom: function(){
            console.log('Signaled to start guest Intercom');
            //Shutdown any previous intercom instance
            if(this.intercomBooted) {
                window.Intercom('shutdown');
            }
            window.Intercom('boot', {
               app_id: INTERCOM_APP_ID,
                widget: {
                    activator: '#IntercomDefaultWidget'
                },
            });
            this.intercomBooted = true;
        },
        activateIntercom: function(user) {
            console.log('Signaled to start user Intercom');
            this.$http.get('profile/intercom').then(function (response) {
                var intercomData = {
                    app_id: INTERCOM_APP_ID,
                    email: (user.actual_email || user.email),
                    name: user.first_name + ' ' + user.last_name,
                    first_name: user.first_name,
                    last_name: user.last_name,
                    user_active_plan: user.plan ? user.plan : 'None',
                    user_on_trial: user.subscription && user.subscription.trial ? "Yes" : "No",
                    widget: {
                        activator: '#IntercomDefaultWidget'
                    },
                };

                $.extend(intercomData, response.data.data);

                if (user.company && user.company.data.name !== "None" ) {
                    intercomData.company = {
                        id: user.company.data.id,
                        name: user.company.data.name,
                        billable: user.company.data.billable
                    }
                }

                if(!auth.isMasqueraded()){
                    if(user.company.data.disable_intercom !== true) {
                        this.intercomBooted ? window.Intercom('update', intercomData) : window.Intercom('boot', intercomData);
                    } else {
                        window.Intercom('shutdown');
                    }
                }

                this.intercomBooted = true;
            });
        },
        eventUserLogin: function(profile, remember) {
            console.log('User logged in.');

            auth.login(profile, remember);

            eventHub.$emit('user.profile', profile);
        },
        eventUserLogout: function() {
            auth.logout();
            this.activateGuestIntercom();

            window.location.href = '/app/logout';
            //this.$router.push({ name: 'login' });
        },
        eventUserProfile: function(profile, updated) {
            console.log('User profile retrieved');

            if(this.intercomBooted) {
                eventHub.$emit('update-intercom');
            }

            if(!updated && this.user !== null) {
                // We already have the profile
                console.log('Already have profile, ignoring')
                return;
            }
            this.user = profile;

            if (window.Bugsnag !== undefined) {
                window.Bugsnag.user = {
                    id: this.user.id,
                    email: (this.user.actual_email || this.user.email),
                };
            }

            if(!this.intercomBooted) {
                this.activateIntercom(this.user);
            }

            // New Notice events
            if(! this.echoBooted) {
                window.Echo.private('App.User.' + this.user.id)
                    .listen('NoticeEvent', (event) => {
                        eventHub.$emit('notice-received', event);
                    })
                    .listen('ScheduledPostEvent', (event) => {
                        eventHub.$emit('scheduled-post-updated', event);
                    });
                this.echoBooted = true;
            }

            this.$store.commit('setUser', profile);

            //Change to user language
            if(profile.dialect_code) {
                this.switchLanguage(profile.dialect_code);
            } else {
                this.switchLanguage(profile.language_id);
            }

            //Dispatch users connections to the store
            this.$http.get('connections').then(function(response) {
                if(response !== undefined && response.body !== undefined && response.body.data !== undefined){
                    let connections = _.map(response.body.data, function(connection){ return connection.connectable.data; });
                    this.$store.commit('setConnections', response.body.data);
                    postAnythingStore.dispatch('setConnections', connections);
                    eventHub.$emit('connections.updated', connections);

                    let pinterestConnection = _.find(connections, connection => connection.type === 'App\\PinterestAccount');

                    if (pinterestConnection !== undefined) {
                        // Check user's Pinterest profile to see if token is still valid
                        this.$http.get('pinterest/profile')
                        .catch(function(e) {
                            if(
                                e.body.message.startsWith('Pinterest error (code: 401)') ||
                                e.body.message.startsWith('getUser() Failure') // v3
                            ) {
                                postAnythingStore.state.pinterest_token_invalid = true;
                            }
                        });

                        // Check if the user is on v3 and show message if not
                        if(!window.pinterest_update && !pinterestConnection.version_3) {
                            window.pinterest_update = true; // Once per app load
                            swal({
                                icon: 'warning',
                                title: this.$i18n.settings.pinterest_update.title,
                                text: this.$i18n.settings.pinterest_update.message,
                                buttons: [this.$i18n.general.cancel, this.$i18n.settings.tab_connections.reconnect]
                            }).then(function(confirmed) {
                                if(confirmed) {
                                    window.location.href = '/connect/pinterest3/auth?reconnect=true';
                                }
                            }.bind(this));
                        }

                        // Also grab boards. May come from cache so may not trigger token error
                        postAnythingStore.dispatch('refreshBoards');
                    }

                    let instagramConnections = connections.filter(connection => connection.type === 'App\\InstagramPage');

                    if (instagramConnections.length > 0) {
                        let ig_update = false;
                        instagramConnections.forEach(ig => {
                            if (!ig.has_insights) {
                                ig_update = true;
                            }
                        });

                        if (ig_update) {
                            swal({
                                icon: 'warning',
                                title: this.$i18n.settings.instagram_update.title,
                                text: this.$i18n.settings.instagram_update.message,
                                buttons: [this.$i18n.general.cancel, this.$i18n.settings.tab_connections.reconnect]
                            }).then(function(confirmed) {
                                if(confirmed) {
                                    window.open(window.location.origin + '/connect/facebook/auth?reconnect=true&permissions=true', '_blank', 'width=700,height=400,location=0,menubar=0,scrollbars=0,status=0,toolbar=0');
                                }
                            }.bind(this));
                        }

                    }
                }
            }.bind(this)).catch(error => {});

            return true;
        },
        eventMasqueradingStarted: function(){
            if(this.intercomBooted) {
                window.Intercom('shutdown');
                console.log('Intercom is being shut down due to a masquerading session in progress...');
            }
        }
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/app.vue